export class ChecklistStepEntity {
  public id!: string;
  public description!: string;
  public displayOrder!: number;
}
